module.exports = __webpack_public_path__ + "img/qr_qr-preview.884b6411.png";